<form class="pre-form" #formulari="ngForm">
  <mat-grid-list cols="4" rows="3" rowHeight="80px">            
      <mat-grid-tile>
          <mat-form-field class="pre-field">
              <mat-select name="tipus-document-identificatiu" placeholder="Tipus document" 
                [formControl]="tipusDocumentIdentificatiuInput" [(ngModel)]="trasllat.alumne.tipusDocument" i18n-placeholder>
                  <mat-option *ngFor="let td of tipusDocuments" [value]="td.value">
                      {{ td.name }}
                  </mat-option>
              </mat-select>
              <mat-error i18n>
                    El document identificatiu no és vàlid!
              </mat-error>              
          </mat-form-field>  
      </mat-grid-tile>      
      <mat-grid-tile>
          <mat-form-field class="pre-field">
              <input type="text" name="document-identificatiu" matInput placeholder="Document identificatiu" disabled 
                [(ngModel)]="trasllat.alumne.documentIdentificatiu" i18n-placeholder>
          </mat-form-field>  
      </mat-grid-tile>                                                                                                                  
      <mat-grid-tile>
          <mat-form-field class="pre-field">
              <mat-select name="sexe" placeholder="Sexe" [(ngModel)]="trasllat.alumne.sexe" i18n-placeholder>
                  <mat-option *ngFor="let td of sexes" [value]="td.value">
                      {{ td.name }}
                  </mat-option>
              </mat-select>
          </mat-form-field>  
      </mat-grid-tile>
      <mat-grid-tile></mat-grid-tile>                                
      <mat-grid-tile>
              <mat-form-field class="pre-field">
                  <input type="text" name="nom" matInput placeholder="Nom" required [(ngModel)]="trasllat.alumne.nom" [disabled]="!trasllat.alumne.isnew" i18n-placeholder>
              </mat-form-field>  
      </mat-grid-tile>
      <mat-grid-tile>
              <mat-form-field class="pre-field">
                  <input type="text" name="cognom1" matInput placeholder="Primer cognom" required [(ngModel)]="trasllat.alumne.cognom1" [disabled]="!trasllat.alumne.isnew" i18n-placeholder>
              </mat-form-field>  
      </mat-grid-tile>
      <mat-grid-tile>
          <mat-form-field class="pre-field">
              <input type="text" name="cognom2" matInput placeholder="Segon cognom" [(ngModel)]="trasllat.alumne.cognom2" [disabled]="!trasllat.alumne.isnew" i18n-placeholder>
          </mat-form-field>  
      </mat-grid-tile>    
      <mat-grid-tile></mat-grid-tile>                                                                    
      <mat-grid-tile>
          <mat-form-field class="pre-field">
              <input matInput name="data-naixement" placeholder="Data de naixement" disabled [ngModel]="trasllat.alumne.dataNaixement " i18n-placeholder="@@71310302ab686b5ac15e8e78e25efffc9aed00db">
          </mat-form-field>                
      </mat-grid-tile>                            
      <mat-grid-tile>
          <mat-form-field class="pre-field">
              <input matInput name="pais-naixement" placeholder="País de naixement" [matAutocomplete]="paisNaixement" required
                  [formControl]="paisNaixementCtrl" [ngModel]="trasllat.alumne.paisNaixement" (ngModelChange)="paisNaixementChange($event)" i18n-placeholder>
              <mat-autocomplete #paisNaixement="matAutocomplete" [displayWith]="utilitats.displayName">
                  <mat-option *ngFor="let x of filteredPaisosNaixement | async" [value]="x">                                        
                      {{ x?.name }}
                  </mat-option>
              </mat-autocomplete>
          </mat-form-field>                            
      </mat-grid-tile>
      <mat-grid-tile *ngIf="trasllat.alumne.paisNaixementEspanya()">
          <mat-form-field class="pre-field">                            
              <input matInput name="poblacio-naixement" placeholder="Població de naixement" [matAutocomplete]="poblacioNaixement" required
                  [formControl]="poblacioNaixementCtrl" [ngModel]="trasllat.alumne.poblacioNaixement" (ngModelChange)="poblacioNaixementChange($event)" i18n-placeholder>
              <mat-autocomplete #poblacioNaixement="matAutocomplete" [displayWith]="utilitats.displayName">
                  <mat-option *ngFor="let x of filteredPoblacionsNaixement | async" [value]="x">                                        
                      {{ x?.name }}
                  </mat-option>
              </mat-autocomplete>
          </mat-form-field>                            
      </mat-grid-tile>
      <mat-grid-tile *ngIf="!trasllat.alumne.paisNaixementEspanya()">
        <mat-form-field class="pre-field">
            <input matInput name="poblacio-naixement-text" placeholder="Població de naixement" [(ngModel)]="trasllat.alumne.poblacioNaixementText" required i18n-placeholder>
        </mat-form-field>                            
      </mat-grid-tile>                            
      <mat-grid-tile>
          <mat-form-field class="pre-field">
              <input matInput name="nacionalitat" placeholder="Nacionalitat" [matAutocomplete]="nacionalitat" required
                  [formControl]="nacionalitatCtrl" [ngModel]="trasllat.alumne.nacionalitat" (ngModelChange)="nacionalitatChange($event)" i18n-placeholder>
              <mat-autocomplete #nacionalitat="matAutocomplete" [displayWith]="utilitats.displayName">
                  <mat-option *ngFor="let x of filteredNacionalitats | async" [value]="x">                                        
                      {{ x?.name }}
                  </mat-option>
              </mat-autocomplete>
          </mat-form-field>                            
      </mat-grid-tile>                    
      <mat-grid-tile colspan="4">
          <mat-checkbox name="discapacitat" class="pre-controls-left" [(ngModel)]="trasllat.alumne.discapacitat" i18n>Marqueu la casella següent si patiu algun tipus de discapacitat</mat-checkbox>        
      </mat-grid-tile>           
      <mat-grid-tile colspan="4" *ngIf="trasllat.potModificar">
          <div class="pre-controls-right">
              <button mat-raised-button color="primary" (click)="continua()" [disabled]="!isValid()" i18n>Continua</button> 
          </div>
      </mat-grid-tile>
  </mat-grid-list>                        
</form>



// WEBPACK FOOTER //
// ./src/app/dades-personals/dades-personals.component.html